import $ from "jquery";
import "slick-carousel";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

(function ($, window) {
  // ✅ Ensure a global namespace object exists
  window.DelhiZoo = window.DelhiZoo || {};
  var DelhiZoo = window.DelhiZoo;

  // =====================
  // Homepage scripts
  // =====================
  DelhiZoo.homePage = {
    init: function () {
      this.initSliders();
      this.initReadMore();
      this.initTextToggle();
      this.initVerticalCarousel();
      this.initIconAnimations();
    },

    // =====================
    // Sliders
    // =====================
    initSliders: function () {
      if (typeof $.fn.slick !== "function") {
        console.warn("⚠️ Slick not available — skipping slider initialization.");
        return;
      }

      const initSlick = (selector, settings) => {
        const $el = $(selector);
        if ($el.length && !$el.hasClass("slick-initialized")) {
          $el.slick(settings);
        }
      };

      const $slider = $(".slider");
      const $currentSlide = $("#currentSlide");
      const $totalSlides = $("#totalSlides");

      if ($slider.length) {
        $slider.on("init reInit afterChange", (event, slick, currentSlide) => {
          const slideCount = slick?.slideCount || 0;
          if ($totalSlides.length) {
            $totalSlides.text(("0" + slideCount).slice(-2));
          }

          const slideNumber =
            typeof currentSlide !== "undefined" && currentSlide !== null
              ? currentSlide + 1
              : 1;

          if ($currentSlide.length) {
            $currentSlide.text(("0" + slideNumber).slice(-2));
          }
        });
      }

      // Slider configs
      initSlick(".slider", {
        dots: false,
        arrows: true,
        infinite: false,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 3000,
        lazyLoad: "ondemand",
      });

      initSlick(".event-slider", {
        dots: true,
        arrows: false,
        infinite: false,
        speed: 500,
        slidesToShow: 3,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 3000,
        lazyLoad: "ondemand",
        responsive: [
          {
            breakpoint: 768,
            settings: "unslick",
          },
        ],
      });

      initSlick(".achievement-slider", {
        dots: true,
        arrows: false,
        infinite: false,
        speed: 500,
        slidesToShow: 3,
        slidesToScroll: 3,
        autoplay: false,
        lazyLoad: "ondemand",
        responsive: [
          {
            breakpoint: 768,
            settings: "unslick",
          },
        ],
      });

      // Ensure counters populate on reload
      if ($slider.length && $slider.hasClass("slick-initialized")) {
        $slider.trigger("init");
      }
    },

    // =====================
    // Read More (jQuery)
    // =====================
    initReadMore: function () {
      $(".info-box .readmore a").off("click").on("click", function (e) {
        e.preventDefault();
        const parentBox = $(this).closest(".info-box");
        const paragraph = parentBox.find("p");
        const image = parentBox.find("img").first();
        const newHeight = window.innerWidth <= 768 ? "100px" : "60px";

        if (paragraph.is(":visible")) {
          paragraph.slideUp(300, () => image.animate({ height: "165px" }, 300));
          $(this)
            .html('read more <img src="/images/home/read-more.png">')
            .removeClass("rotated");
        } else {
          image.animate({ height: newHeight }, 300, () =>
            paragraph.slideDown(300)
          );
          $(this)
            .html('read less <img src="/images/home/read-more.png">')
            .addClass("rotated");
        }
      });
    },

    // =====================
    // Text Toggle (Vanilla)
    // =====================
    initTextToggle: function () {
      document.querySelectorAll(".readmore").forEach((toggle) => {
        toggle.addEventListener("click", function () {
          const shortText = this.previousElementSibling.previousElementSibling;
          const fullText = this.previousElementSibling;

          if (fullText.style.display === "none") {
            fullText.style.display = "inline";
            shortText.style.display = "none";
            this.innerHTML = 'read less <img src="/images/home/read-more.png">';
          } else {
            fullText.style.display = "none";
            shortText.style.display = "inline";
            this.innerHTML = 'read more <img src="/images/home/read-more.png">';
          }
        });
      });
    },

    // =====================
    // Vertical Carousel
    // =====================
    initVerticalCarousel: function () {
      if ($(".vertical-carousel").length) {
        $(".vertical-carousel").slick({
          vertical: true,
          slidesToShow: 3,
          slidesToScroll: 1,
          prevArrow: $(".slick-prev"),
          nextArrow: $(".slick-next"),
          infinite: true,
        });
      }
    },

    // =====================
    // Icon Animations
    // =====================
    initIconAnimations: function () {
      let iconsVisible = true;

      $("#right-arrow")
        .off("click")
        .on("click", function () {
          if (iconsVisible) {
            $(".adopt-icon, .partner-icon, .left-arrow").animate(
              { left: "-20%", opacity: 0 },
              500
            );
            $(".live-icon, .zoo-icon").animate(
              { right: "-200px", opacity: 0 },
              500
            );
          } else {
            $(".adopt-icon, .partner-icon").animate(
              { left: "3%", opacity: 1 },
              500
            );
            $(".left-arrow").animate({ left: "4.5%", opacity: 1 }, 500);
            $(".live-icon, .zoo-icon").animate(
              { right: "3%", opacity: 1 },
              500
            );
          }
          iconsVisible = !iconsVisible;
        });

      $("#left-arrow")
        .off("click")
        .on("click", function () {
          $(".adopt-icon, .partner-icon, .left-arrow").animate(
            { left: "-20%", opacity: 0 },
            500
          );
          $(".live-icon, .zoo-icon").animate(
            { right: "-200px", opacity: 0 },
            500
          );
          iconsVisible = false;
        });
    },
  };

  window.DelhiZoo = DelhiZoo;

  // Initialize on document ready
  $(document).ready(function () {
    DelhiZoo.homePage.init();
  });
})(jQuery, window);
